export const DEFAULT_OG_IMAGE = 'puma-og-logo.png';
export const DEFAULT_OG_IMAGE_PATH = 'custom_images/';
